module.exports = __webpack_public_path__ + "img/main.b2f6db61.jpg";